import styled from 'styled-components'

export const GenericInlineText = styled.span`
  color: var(--sn-stylekit-paragraph-text-color);
  font-size: var(--sn-stylekit-font-size-p);
  margin: 0 10px;
`
